module.exports = __webpack_public_path__ + "static/TestimonialsBg-2bb69c43f3e324a7a93d68516f82c6c5.svg";